import './payment-option-row.css';

import { Util } from "../../../../../utils/util";
import { OnlinePaymentOption } from '../../../../../types/enums';

export interface IPaymentOptionElement {
    id: OnlinePaymentOption;
    name: string;
    iconHtml: string;
    radioGroupName: string;
    isSelected: boolean;
    ltag?: string;
    onSelect: () => void;
}

export class PaymentOptionRow {
    readonly element: HTMLElement;
    private readonly _radio: HTMLInputElement;
    private readonly _rowId: string;
    private readonly _radioId: string;

    constructor(
        private readonly _params: IPaymentOptionElement,
        private readonly _onActivate: (params: IPaymentOptionElement) => void
    ) {
        this._rowId = `li_${this._params.radioGroupName}_${this._params.id}`;
        this._radioId = `rdo_${this._params.radioGroupName}_${this._params.id}`;
        this.element = this._build();
        this._radio = this.element.querySelector(`#${this._radioId}`) as HTMLInputElement;
        this._attachHandlers();
    }

    setChecked(checked: boolean): void {
        this._radio.checked = checked;
    }

    private _build(): HTMLElement {
        const nameId = `${this._params.radioGroupName}_${this._params.id}_name`;

        const html = `
            <label id="${this._rowId}" class="option-row payment-option-row">
                <div class="payment-option-label">
                    <span class="payment-option-icon" aria-hidden="true">${this._params.iconHtml}</span>
                    <span id="${nameId}" class="payment-option-name" ${this._params.ltag ? `ltag="${this._params.ltag}"` : ""}>${this._params.name}</span>
                </div>

                <div class="custom-radio">
                    <input type="radio" id="${this._radioId}" name="${this._params.radioGroupName}"
                           aria-labelledby="${nameId}"
                           ${this._params.isSelected ? `checked="checked"` : ""}>
                    <span class="checkmark"></span>
                </div>
            </label>`;

        return Util.createHtmlElementFromTemplate(html);
    }

    private _attachHandlers(): void {
        this.element.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();

            // Browsers fire a "click" on a radio (which bubbles up to this label) both for a real
            // pointer click and when arrow keys move the native selection within a same-name radio
            // group -- and we want arrow-key browsing to select immediately, the same as a native
            // radio group (matching the Domino's-style pattern this UI follows), not require a
            // separate Enter/Space to commit.
            this.element.dataset.humanClick = String(event.isTrusted);
            requestAnimationFrame(() => this._onActivate(this._params));
        });

        if (this._radio) {
            this._radio.onclick = null;

            this._radio.addEventListener("keydown", (event: KeyboardEvent) => {
                if (event.key === " " || event.key === "Spacebar" || event.key === "Enter") {
                    event.preventDefault();
                    this.element.dataset.humanClick = "true";
                    requestAnimationFrame(() => this._onActivate(this._params));
                }
            });
        }
    }
}
